import React, {useState} from 'react';
import Map from "./Map";
import {Row, Col, Container } from 'reactstrap';
import CreateNodeForm from "./CreateNodeForm";
import CreateEdgeForm from "./CreateEdgeForm";
import SelectedNode from "./SelectedNode";
// @ts-ignore
import styled from 'styled-components/macro';

const MapHeader = styled.div`
  margin: 1rem 0;
`;

function NodeEditor() {
  const [selectedNode, setSelectedNode] = useState('');
  const [selectedEdge, setSelectedEdge] = useState('');

  return (
    <Container>
      <MapHeader>
        <Row>
          <Col>
            <CreateNodeForm />
          </Col>
          <Col>
            <CreateEdgeForm />
          </Col>
        </Row>
        <Row>
          <Col>
            <SelectedNode
              selectedNode={selectedNode}
              selectedEdge={selectedEdge}
              setSelectedEdge={setSelectedEdge}
            />
          </Col>
        </Row>
      </MapHeader>
      <Row>
        <Col>
          <Map
            selectedNode={selectedNode}
            setSelectedNode={setSelectedNode}
            selectedEdge={selectedEdge}
            setSelectedEdge={setSelectedEdge}
          />
        </Col>
      </Row>
    </Container>
  )
}

export default NodeEditor;

